import el from "@cypherpotato/el";


/// theme preference
export const themePreference = el.state.create(
    window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light"
);

window.matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', ({ matches }) => {
        if (matches) {
            themePreference.value = "dark";
        } else {
            themePreference.value = "light";
        }
    })

/// current path
export const currentPath = el.state.create(window.location.pathname);